import types from "../../utils/actionTypes";

const initialState = {
    currentTab: null
}

const NewOrders = "NewOrders";
const InProgress = "InProgress";
const ReadyForShipment = "ReadyForShipment";
const OutForDelivery = "OutForDelivery";

export default function(state=initialState, action){
    switch(action.type){
        case types.NEWORDERS_TAB:
            return {...state, currentTab: NewOrders}
        case types.INPROGRESS_TAB:
            return {...state, currentTab: InProgress}
        case types.SHIPMENT_TAB:
            return {...state, currentTab: ReadyForShipment}
        case types.DELIVERY_TAB:
            return {...state, currentTab: OutForDelivery}
        default: return {...state}
    }  
}